import { put } from "@src/appV2/api";
import { environmentConfig } from "@src/appV2/environment";
import { APP_V2_APP_EVENTS } from "@src/appV2/lib";
import { useMutation } from "@tanstack/react-query";
import { z } from "zod";

import { shiftTransferDtoSchema } from "../types";

export const updateShiftTransferResponseSchema = z.object({
  data: shiftTransferDtoSchema.optional(),
});
export type UpdateShiftTransferResponse = z.infer<typeof updateShiftTransferResponseSchema>;

export const updateShiftTransferRequestSchema = z.object({
  accepted: z.boolean(),
});
export type UpdateShiftTransferPayload = z.infer<typeof updateShiftTransferRequestSchema>;

export function useUpdateShiftTransfer() {
  return useMutation({
    mutationFn: async (values: {
      shiftId: string;
      toWorkerId: string;
      payload: UpdateShiftTransferPayload;
    }) => {
      const response = await put({
        url: `${environmentConfig.REACT_APP_WORKER_APP_BFF_URL}/shifts/${values.shiftId}/transfers/${values.toWorkerId}`,
        data: values.payload,
        requestSchema: updateShiftTransferRequestSchema,
        responseSchema: updateShiftTransferResponseSchema,
      });

      return response.data;
    },
    meta: {
      logErrorMessage: APP_V2_APP_EVENTS.UPDATE_SHIFT_TRANSFER_FAILURE,
    },
  });
}
